import { useState, useEffect } from "react"
import { baseDate, zoomLevels } from "../utils/settings"
import SearchPopup from "./SearchPopup"
import { handleGoToDate } from "../utils/datePositionUtils"
import SesAyarlari from "./SesAyarlari"
import ZoomControl from "./ZoomControl"
import TarihGosterimi from "./TarihGosterimi"
import EventNavigationControls from "./EventNavigationControls"

const KullaniciNavbar = ({
	currentDate,
	onZoomChange,
	onScrollPositionChange,
	onEventSelect,
	interval,
	categories,
	filteredCategories = [],
	setFilteredCategories,
	timeFilter = { active: false },
	textFilter = { active: false },
	isAuthenticated,
	selectedEvent,
	onNext,
	onPrevious,
	isAutoPlaying,
	onAutoPlayToggle,
	onGoToFirst,
	onGoToLast,
	isReading,
	onReadingStateUpdate,
}) => {
	const [showSearchPopup, setShowSearchPopup] = useState(false)
	
    const [currentZoomIndex, setCurrentZoomIndex] = useState(2);
	useEffect(() => {
		let savedZoomIndex = localStorage.getItem('timelineZoomIndex');
		if (savedZoomIndex)
		{
			savedZoomIndex = savedZoomIndex ? parseInt(savedZoomIndex, 10) : 2
			// console.log("savedZoomIndex ", savedZoomIndex)
			setCurrentZoomIndex(savedZoomIndex);
		}
		else
		localStorage.setItem('timelineZoomIndex',currentZoomIndex)
	}, [])
	

	const [isLargeScreen, setIsLargeScreen] = useState(
		window.innerWidth >= 1024
	)

	useEffect(() => {
		const handleResize = () => {
			setIsLargeScreen(window.innerWidth >= 1024)
		}

		window.addEventListener("resize", handleResize)
		return () => window.removeEventListener("resize", handleResize)
	}, [])

	// Component mount olduğunda varsayılan zoom seviyesini ayarla
	useEffect(() => {
		onZoomChange?.(zoomLevels[2],1,0)
	}, [])

	// Initialize speech settings display values
	useEffect(() => {
		// Initialize volume value display
		const volumeElement = document.getElementById("volume-value")
		if (volumeElement) {
			volumeElement.textContent = "100%"
		}

		// Initialize rate value display
		const rateElement = document.getElementById("rate-value")
		if (rateElement) {
			rateElement.textContent = "1x"
		}
	}, [])

	const handleZoomIn = () => {
		if (currentZoomIndex > 0) {
			const newIndex = currentZoomIndex - 1
			setCurrentZoomIndex(newIndex)
			onZoomChange?.(zoomLevels[newIndex])
			if (newIndex===newIndex)   // NaN kontrolü
				localStorage.setItem('timelineZoomIndex',newIndex)

		}
	}

	const handleZoomOut = () => {
		if (currentZoomIndex < zoomLevels.length - 1) {
			const newIndex = currentZoomIndex + 1
			setCurrentZoomIndex(newIndex)
			onZoomChange?.(zoomLevels[newIndex])
			if (newIndex===newIndex)   // NaN kontrolü
				localStorage.setItem('timelineZoomIndex',newIndex)
		}
	}

	const isAnyFilterActive =
		(filteredCategories && filteredCategories.length > 0) ||
		(timeFilter &&
			timeFilter.active &&
			(timeFilter.startYear !== null || timeFilter.endYear !== null)) ||
		(textFilter && textFilter.active && textFilter.text)

	const getActiveFilterCount = () => {
		let count = 0
		if (filteredCategories && filteredCategories.length > 0) count++
		if (
			timeFilter &&
			timeFilter.active &&
			(timeFilter.startYear !== null || timeFilter.endYear !== null)
		)
			count++
		if (textFilter && textFilter.active && textFilter.text) count++
		return count
	}

	// Function to trigger filter update notification
	const notifyFilterUpdate = () => {
		document.dispatchEvent(new CustomEvent("timelineFilterUpdated"))
	}

	// Add effect to monitor filter changes and update UI
	useEffect(() => {
		if (isAnyFilterActive) {
			notifyFilterUpdate()
		}
	}, [isAnyFilterActive, filteredCategories, timeFilter, textFilter])

	return (
		<>
			<nav className="fixed right-0 bg-gray-200 shadow-md z-40 h-12 left-[200px] top-16">
				<div className="flex items-center h-full">
					{/* Sol taraf - Kategoriler, Zoom ve Event Navigation */}
					<div className="flex items-center space-x-4 px-4">
						<ZoomControl
							handleZoomIn={handleZoomIn}
							handleZoomOut={handleZoomOut}
							zoomLevels={zoomLevels}
							currentZoomIndex={currentZoomIndex}
						/>
						<TarihGosterimi
							currentDate={currentDate}
							onScrollPositionChange={onScrollPositionChange}
							interval={interval}
						/>
						{isLargeScreen && (
							<EventNavigationControls
								selectedEvent={selectedEvent}
								isReading={isReading}
								onPrevious={onPrevious}
								onGoToFirst={onGoToFirst}
								onGoToLast={onGoToLast}
								onNext={onNext}
								onAutoPlayToggle={onAutoPlayToggle}
								onReadingStateUpdate={onReadingStateUpdate}
								isAutoPlaying={isAutoPlaying}
							/>
						)}
					</div>

					{/* Sağ taraf - Arama ve Ses Ayarları */}
					<div className="flex items-center space-x-4 ml-auto px-4">
						<button
							onClick={() => setShowSearchPopup(true)}
							className="flex items-center justify-center space-x-2 text-gray-700 hover:bg-gray-300 rounded transition-colors py-1.5 px-3 gap-1"
						>
							<svg
								xmlns="http://www.w3.org/2000/svg"
								className="h-4 w-4"
								fill="none"
								viewBox="0 0 24 24"
								stroke="currentColor"
							>
								<path
									strokeLinecap="round"
									strokeLinejoin="round"
									strokeWidth={2}
									d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
								/>
							</svg>
							<span>Ara</span>
						</button>

						<SesAyarlari />
					</div>
				</div>
				{/* Sayfanın ortasına ortalanmış TarihGosterimi */}
				{/* <div className="fixed right-0 left-0 top-[70px] w-screen flex justify-center z-[999]">
				<TarihGosterimi
					currentDate={currentDate}
					onDateChange={(date) => {
						const newScrollPos = handleGoToDate(
							date,
							interval,
							baseDate
						)
						onScrollPositionChange(newScrollPos)
					}}
				/>
				</div> */}
			</nav>

			{showSearchPopup && (
				<SearchPopup
					onClose={() => setShowSearchPopup(false)}
					onEventSelect={onEventSelect}
					categories={categories}
					filteredCategories={filteredCategories}
					setFilteredCategories={setFilteredCategories}
					timeFilter={timeFilter}
					textFilter={textFilter}
					isOpen={showSearchPopup}
				/>
			)}
		</>
	)
}

export default KullaniciNavbar
